import { useState } from "react";

import PropTypes from "prop-types";
import { Card, Dropdown, Button } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import { useLoader } from "@/hooks/LoaderProvider";
import UserDialog from "@/components/shared/dialogs/User_Dialog/Index";

const AttendeeCard = ({ attendee, onClick }) => {
  const { showLoader, hideLoader } = useLoader();
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleOpenDialog = () => {
    showLoader();
    setTimeout(() => {
      hideLoader();
      setIsDialogVisible(true);
    }, 1000);
  };

  const handleMenuClick = ({ key }) => {
    if (key === "message" || key === "block") {
      handleOpenDialog();
    }
  };

  const handleCardClick = () => {
    if (onClick) {
      onClick(attendee.id);
    }
  };

  return (
    <>
      <Card
        className="w-full shadow-sm cursor-pointer"
        onClick={handleCardClick}>
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 overflow-hidden">
            <Avatar src={attendee.avatar} size="large" shape="circle" />
            <span className="font-medium text-darkGrey text-sm sm:text-base whitespace-nowrap overflow-hidden text-ellipsis">
              {attendee.name}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Button
              type="primary"
              style={{
                backgroundColor: "var(--veegil-color-lighter-blue)",
                color: "var(--veegil-color-primary)",
                minWidth: "80px",
                padding: "0 8px",
                height: "32px",
                fontSize: "12px",
              }}
              onClick={(e) => e.stopPropagation()}>
              {attendee.confirmed ? "Confirmed" : "Confirm"}
            </Button>
            <Dropdown
              menu={{
                items: [
                  { key: "message", label: "Message User" },
                  { key: "block", label: "Block this user" },
                ],
                onClick: (e) => handleMenuClick(e),
              }}
              placement="bottomRight"
              trigger={["click"]}>
              <CustomMoreOptions
                variant="filled"
                onClick={(e) => e.stopPropagation()}
                color="black"
                orientation="vertical"
                size="small"
              />
            </Dropdown>
          </div>
        </div>
      </Card>

      <UserDialog
        isVisible={isDialogVisible}
        onClose={() => setIsDialogVisible(false)}
        user={attendee}
      />
    </>
  );
};

AttendeeCard.propTypes = {
  attendee: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    avatar: PropTypes.string,
    confirmed: PropTypes.bool,
    username: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

export default AttendeeCard;
